// Framework and third-party non-ui
import React, { useState } from 'react';

// App components
import Login from 'components/Login';
import UserPopover from './UserPopover';
import { signOut } from 'data/oauth';

// JSON & Styles
import { StyledUser } from './User-styled';
import { StyledList, StyledListItem } from './List-Styled';

// Third-party components (buttons, icons, etc.)
import Popover from 'calcite-react/Popover';
import SignOutIcon from 'calcite-ui-icons-react/SignOutIcon';

const User = ({ userInfo }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const getAvatar = ({ userInfo, size, ...rest }) => {
    return <UserPopover userInfo={userInfo}></UserPopover>;
  };

  const getUser = () => {
    // Display Login if user isn't logged in yet
    if (!userInfo) {
      return <Login />;
    }

    return (
      <Popover
        appendToBody
        open={menuOpen}
        onRequestClose={() => setMenuOpen(false)}
        targetEl={getAvatar({
          userInfo,
          size: 36,
          onClick: () => setMenuOpen(true),
          style: {
            cursor: 'pointer',
            backgroundColor: '#675CAB',
          },
        })}
      >
        <StyledList>
          <StyledListItem onClick={signOut} leftNode={<SignOutIcon />}>
            Logout
          </StyledListItem>
        </StyledList>
      </Popover>
    );
  };

  return <StyledUser data-testid="User">{getUser()}</StyledUser>;
};

export default User;
